// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'
// Import Vue dependencies
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import store from './store'
import router from './router'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import VueTour from 'vue-tour'

require('./styles/decidedly-tour.css')

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(VueTour)

// Load all locales and remember context
function loadMessages() {
  const context = require.context("./locales", true, /[a-z0-9-_]+\.json$/i);

  const messages = context
    .keys()
    .map((key) => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
    .reduce(
      (messages, { key, locale }) => ({
        ...messages,
        [locale]: context(key),
      }),
      {}
    );

  return { messages };
}

const { messages } = loadMessages();

// VueI18n instance
const i18n = new VueI18n({
  locale: "en",
  messages,
});

let app = ''

// NOTE: These are OK to have here and are considered public.
// See https://firebase.google.com/docs/projects/learn-more#config-files-objects
const firebaseConfig = {
  apiKey: "AIzaSyBD2LeiPTWomuxKTq_skzS3V-hvuqktQ8k",
  authDomain: "decidedly.firebaseapp.com",
  databaseURL: "https://decidedly.firebaseio.com",
  projectId: "decidedly",
  storageBucket: "decidedly.appspot.com",
  messagingSenderId: "461029455627",
  appId: "1:461029455627:web:095f96f4781b659eea540e",
  measurementId: "G-3L76L3281T"
}

firebase.initializeApp(firebaseConfig)

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
